import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-chat-hero-suggested-questions',
    templateUrl: './chat-hero-suggested-questions.component.html',
    styleUrl: './chat-hero-suggested-questions.component.scss',
})
export class ChatHeroSuggestedQuestionsComponent {
    @Input() suggestedQuestions: string[] = [];
    @Output() questionClick = new EventEmitter<string>();

    handleClick(question: string) {
        this.questionClick.emit(question);
    }
}
